import { useMemo } from "react";
import { SuggestedFilterInfo, AllSuggestedFilterInfo } from "web/types/feed-filters";
import { CategoryFilterOption, UniversalFiltersData } from "web/types/universal-filters";

function findNestedSuggestions(
    filters: CategoryFilterOption[],
    _data?: SuggestedFilterInfo
): SuggestedFilterInfo {
    if (!_data) {
        _data = { suggestions: [] };
    }
    for (let filter of filters) {
        if (
            filter.is_suggested &&
            (!filter.checked || (filter.name === "gender" && filter.value === "all"))
        ) {
            _data.suggestions.push(filter);
        }

        if (filter.children && filter.children.length > 0) {
            let suggestedFilterInfo: SuggestedFilterInfo;
            suggestedFilterInfo = findNestedSuggestions(filter.children as CategoryFilterOption[]);
            _data.suggestions = [..._data.suggestions, ...suggestedFilterInfo.suggestions];
        }
    }

    return _data;
}

export function useSuggestedFilterInfo(
    displayedFilters: UniversalFiltersData
): AllSuggestedFilterInfo {
    return useMemo(() => {
        let filterInfo: AllSuggestedFilterInfo = {};
        for (let section of displayedFilters.filter_section_list) {
            let suggested: SuggestedFilterInfo;
            suggested = findNestedSuggestions(
                section.option_groups[0].options as CategoryFilterOption[]
            );
            filterInfo[section.id] = suggested;
        }
        return filterInfo;
    }, [displayedFilters]);
}
